import { Container } from "@ubnt/store.core/lib/components/Container";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";
import styled, { css } from "styled-components";

const HEADER_HEIGHT = 48;

const getContainerTopSpacing = (top: number, isMainSection: boolean) => {
  if (!top) {
    return 0;
  }

  return isMainSection ? HEADER_HEIGHT + top : top;
};

export const StyledContainer = styled(Container)<{
  $noPadding?: boolean;
  $isMainSection?: boolean;
  $spacing?: { top: number; bottom: number };
}>`
  padding-bottom: 100px;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    padding-bottom: 64px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    padding-bottom: 32px;
  }

  ${({ $noPadding }) =>
    $noPadding &&
    css`
      padding-bottom: 0 !important;
    `}

  ${({ $spacing, $isMainSection }) => {
    return (
      $spacing &&
      css`
        padding-top: ${getContainerTopSpacing($spacing.top, $isMainSection)}px;
        padding-bottom: ${$spacing.bottom}px;

        @media ${BREAKPOINTS.TABLET_AND_DOWN} {
          padding-top: ${getContainerTopSpacing(
            $spacing.top * 0.75,
            $isMainSection,
          )}px;
          padding-bottom: ${$spacing.bottom * 0.75}px;
        }

        @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
          padding-top: ${getContainerTopSpacing(
            $isMainSection ? $spacing.top : $spacing.top * 0.5,
            $isMainSection,
          )}px;
          padding-bottom: ${$spacing.bottom * 0.5}px;
        }
      `
    );
  }}
`;
